// extracted by mini-css-extract-plugin
export default {"AboutUsContent":"AboutUs_AboutUsContent__Z74Ag","AboutUsImage":"AboutUs_AboutUsImage__Qo-an"};